module.exports = __webpack_public_path__ + "img/37a-config-ausentes-form.f5400701.png";